import { VaxFormTitle } from 'components/impfschaeden/assistent/components/VaxFormTitle.js';
import useRemoveFile from 'components/impfschaeden/assistent/hooks/useRemoveFile.js';
import useUploadVaxFile from 'components/impfschaeden/assistent/hooks/useUploadVaxFile.js';
import { Container, Form } from 'components/ui';
import mapValues from 'lodash/mapValues';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { formActions } from 'store/vaxFormDataSlice';
import styled from 'styled-components';
import { BilderVideosForm } from 'VaxForm_11_BilderVideos/components/BilderVideosForm.js';

const FormStyle = styled(Form)`
	width: '100%';
	align-items: 'center';
`;

const Step11 = (props) => {
	const [t] = useTranslation(['translation']);
	const uploadVaxFile = useUploadVaxFile();
	const files = useSelector((state) => state.vaxFormData.vax_entry_files);
	const user = useSelector((state) => state.settings.currentUser);
	const language = useSelector((state) => state.settings.language);
	const validation = useSelector((state) => state.formValidation.vaxStep11);
	const removeFile = useRemoveFile();

	const [translatedValidation, setTranslatedValidation] = useState({});
	useEffect(() => {
		if (
			!validation?.vax_entry_files?.length &&
			!validation?.vax_entry_files?.length == 0
		) {
			return;
		}
		setTranslatedValidation({
			vax_entry_files: validation?.vax_entry_files?.map((item) => {
				return mapValues(item, (value) => {
					return t('validation.' + value);
				});
			}),
		});
	}, [validation, user, language]);

	return (
		<>
			<form
				className={FormStyle}
				onSubmit={(e) => {
					e.preventDefault();
					props.next();
				}}
			>
				<Container spacing={4}>
					<VaxFormTitle
						title={t('impfschaeden.erfassen.foto_video_impfschaden')}
						edit={props.edit}
					/>
					<BilderVideosForm
						uploadVaxFile={uploadVaxFile}
						files={files}
						removeFile={removeFile}
						changeFileOrder={formActions.changeFileOrder}
						validation={translatedValidation}
					/>
				</Container>
			</form>
		</>
	);
};

Step11.propTypes = {
	anotherPerson: PropTypes.bool,
	next: PropTypes.func,
	edit: PropTypes.bool,
};

export default Step11;
